import { motion } from "framer-motion";
import { useLanguage } from "../i18n/LanguageContext";
import { languages } from "../i18n/translations";
import { scrollToSection } from "../lib/scroll";

export const Header = () => {
  const { lang, setLang, t } = useLanguage();

  const links = [
    { id: "hero", label: t.nav.home },
    { id: "contribute", label: t.nav.contribute },
    { id: "about", label: t.nav.about },
    { id: "contact", label: t.nav.contact },
  ];

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.6, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-foreground/10 bg-background/70 backdrop-blur-xl"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 h-16 flex items-center justify-between">
        <button
          data-testid="header-wordmark"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="text-sm font-light uppercase tracking-[0.25em] hover:opacity-60 transition-opacity duration-300"
        >
          Camila Valentoni
        </button>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}-link`}
              onClick={() => scrollToSection(l.id)}
              className="text-xs uppercase tracking-[0.2em] text-foreground/60 hover:text-foreground transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-1" data-testid="language-switcher">
          {languages.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-${l.code}-button`}
              onClick={() => setLang(l.code)}
              className={`px-2 py-1 text-xs tracking-[0.15em] transition-colors duration-300 ${
                lang === l.code
                  ? "text-foreground border-b border-foreground"
                  : "text-foreground/40 hover:text-foreground/80"
              }`}
            >
              {l.label}
            </button>
          ))}
        </div>
      </div>
    </motion.header>
  );
};
